import * as React from "react";
import { Calendar, CircleQuestionMark } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function PatioDoorRepairServicesInVarennes() {
  const serviceAreas = [{
    name: "Montgomery County",
    path: "/ServiceAreasPage"
  }, {
    name: "Howard County",
    path: "/ServiceAreasPage"
  }, {
    name: "Frederick County",
    path: "/ServiceAreasPage"
  }, {
    name: "Northern Virginia",
    path: "/ServiceAreasPage"
  }, {
    name: "View All Service Areas",
    path: "/ServiceAreasPage",
    isLast: true
  }];
  return <section data-section-id="252606" id="siding-replacement-hero" className="bg-background text-foreground py-16 md:py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-primary rounded-lg blur-3xl" />
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-primary/10 to-transparent" />
      </div>

      <div className="page-container relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="flex flex-col items-start text-left">
            <div className="inline-flex items-center rounded-md border border-secondary/30 bg-secondary/10 px-3 py-1 text-sm font-medium text-secondary-500 mb-6">
              <span className="flex h-2 w-2 rounded-md bg-secondary-500 mr-2"></span>
              Expert Siding Solutions
            </div>
            
            <h1 className="font-default text-4xl md:text-5xl lg:text-[var(--font-size-h1)] font-bold leading-tight mb-6 text-balance text-primary-500">
              Siding That Transforms Your Home's Look & Protection
            </h1>

            <nav className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm font-medium mb-8 text-muted-foreground">
              <span className="text-foreground/70">Serving:</span>
              {serviceAreas.map((area, i) => <React.Fragment key={i}>
                  <Link to={area.path} className={`hover:text-secondary-500 transition-colors ${area.isLast ? "text-secondary-500 font-semibold underline underline-offset-4" : ""}`} data-index={i}>
                    {area.name}
                  </Link>
                  {!area.isLast && <span className="text-muted-foreground/40">•</span>}
                </React.Fragment>)}
            </nav>
            
            <p className="font-default text-lg md:text-[var(--font-size-body)] text-muted-foreground mb-4 max-w-xl text-pretty">
              Enhance your home's curb appeal and energy efficiency with our premium siding options in Montgomery County, Howard County, Frederick County, and Northern Virginia. From vinyl to fiber cement, we provide 30+ year lifespans and exceptional durability.
            </p>
            <p className="font-default text-lg md:text-[var(--font-size-body)] text-muted-foreground mb-8 max-w-xl text-pretty">Transform your home's curb appeal.&nbsp;</p>
            
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
             
              
              <Button asChild variant="secondary" size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive has-[>svg]:px-4 w-full sm:w-auto text-base h-12 px-6 hover:bg-secondary-900 text-secondary-foreground rounded-md shadow-md bg-secondary">
                <Link to="/ContactPage">
                  <CircleQuestionMark className="mr-2 size-5" />
                  Start Your Free Siding Assessment
                </Link>
              </Button>
            </div>

            <div className="mt-6 text-sm text-muted-foreground font-default">
              <p className="mb-2">Explore other exterior services:</p>
              <div className="flex flex-wrap gap-x-4 gap-y-2">
                <Link to="/RoofRepairPage" className="text-primary-500 hover:text-secondary-500 font-medium transition-colors">Roof Repair</Link>
                <Link to="/GutterInstallationPage" className="text-primary-500 hover:text-secondary-500 font-medium transition-colors">Gutters</Link>
                <Link to="/StormDamageRepairPage" className="text-primary-500 hover:text-secondary-500 font-medium transition-colors">Storm Damage</Link>
              </div>
            </div>
            
            <div className="mt-8 flex items-center gap-4 text-sm text-muted-foreground font-default">
              
              <p></p>
            </div>
          </div>

          {}
          <div className="w-full relative">
            <div className="absolute -inset-4 bg-secondary/10 rounded-md blur-2xl -z-10" />
            <AspectRatio ratio={4 / 3} className="bg-muted/10 rounded-md overflow-hidden shadow-2xl border border-border">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/durable_siding_exterior_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/durable_siding_exterior_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/durable_siding_exterior_hero.png-wvc-sizes" alt="Modern home with new durable siding installation" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700 ease-out" loading="lazy" decoding="async" />
              
              {}
              <div className="absolute bottom-6 left-6 bg-background text-foreground p-4 rounded-md shadow-lg flex items-center gap-4 max-w-[240px] border border-border">
                <div className="bg-primary/10 p-3 rounded-md text-primary-500">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shield-check"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2-1 4-2 8-2 4 0 6 1 8 2a1 1 0 0 1 1 1z" /><path d="m9 12 2 2 4-4" /></svg>
                </div>
                <div>
                  <p className="font-default font-bold text-sm leading-tight">30+ year lifespan guarantee</p>
                  <p className="font-default text-xs text-muted-foreground mt-0.5">Premium Material Warranty</p>
                </div>
              </div>
            </AspectRatio>
          </div>

        </div>
      </div>
    </section>;
}